import { Avatar, Button, Col, notification, Row, Spin } from 'antd'
import CookieService from "encrypted-cookie";

import {
    CloseOutlined,
    UserOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { getUserProfileDetailsApi, logOutApi } from '../config/Api';
import { eraseCookie } from '../config/CookieScript';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

export const ProfileSection = (props) => {
    const navigate = useNavigate()

    const [userData, setUserData] = useState()
    const [loading, setLoading] = useState(false)

    const getUserProfileDetails = () => {
        setLoading(true)

        let userId = localStorage.getItem('id')
        getUserProfileDetailsApi(userId)
            .then((res) => {
                if (res.status === 200) {
                    setUserData(res.data.data);
                    setLoading(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
                setLoading(false)

            });
    }

    useEffect(() => {
        getUserProfileDetails()
    }, []);

    // const logOut = async () => {
    //     // logOutApi()
    //     //     .then((res) => {
    //     //         eraseCookie('auth_token')
    //     //         eraseCookie('user_name')
    //     //         navigate('/')
    //     //     })
    //     // .finally(() => {
    //     //     eraseCookie('auth_token')
    //     //     navigate('/')
    //     // })

    //     logOutApi()
    //         .then((res) => {
    //             navigate('/')
    //         })
    //         .finally(() => {
    //             eraseCookie('auth_token')
    //             // eraseCookie('user_name')
    //             // eraseCookie('role')
    //             localStorage.clear()
    //             navigate('/')
    //             props.setOpen(false)
    //         })
    // }

    const logOut = async () => {
        logOutApi()
            .then((res) => {
                // Additional actions you want to perform on successful logout
                // eraseCookie('auth_token');
                // const cookies = CookieService.getAll();

                // Iterate over each cookie and remove it
                // Object.keys(cookies).forEach(cookieName => {
                //     CookieService.remove(cookieName);
                // });
                // CookieService.remove('auth_token');
                document.cookie = 'auth_token' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                document.cookie = 'user_name' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                document.cookie = 'role' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                // CookieService.remove('user_name');
                // CookieService.remove('role');

                // eraseCookie('user_name');
                // eraseCookie('role');
                localStorage.clear();
                navigate('/');
                props.setOpen(false);
            })
            .finally(() => {
                // Common actions to be performed in both success and failure cases
                // eraseCookie('auth_token');
                // const cookies = CookieService.getAll();

                // Iterate over each cookie and remove it
                // Object.keys(cookies).forEach(cookieName => {
                //     CookieService.remove(cookieName);
                // });
                document.cookie = 'auth_token' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                document.cookie = 'user_name' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                document.cookie = 'role' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                // CookieService.remove('user_name');
                // CookieService.remove('role');
                navigate('/');
            });
    };

    return (
        <div className="userProfileSection">
            <Spin spinning={loading} className="spinner-code">

                <Row className="profileCard3 pt-2 pb-2 rounded mt-3 mb-3">
                    <CloseOutlined
                        className="pe-2 justify-content-end"
                        onClick={() => props.setOpen(false)}
                    />
                    <Col span={24} className="text-center my-3">
                        <Avatar shape="square" className='rounded' size="large" icon={<UserOutlined />} />
                    </Col>
                    <Col span={24}>

                        <h5><b>{userData?.name || ''}</b></h5>
                        <p>{userData?.email || ''}</p>
                        <p><b>Role:</b> {userData?.role || ''}</p>
                    </Col>
                </Row>
                <Row gutter={[8, 0]} className="profileCard2 xl:h-[5rem] rounded">
                    {/* <Col xxl={12} xl={{ span: 18, offset: 3 }}>
                        <Link to={{ pathname: '/user-profile' }} >
                            <Button icon={<UserOutlined />} id="profileBtn" onClick={() => props.setOpen(false)}>My Account</Button>
                        </Link>
                    </Col>
                    <Col xxl={12} xl={{ span: 18, offset: 3 }}>
                        <Button icon={<LogoutOutlined />} id="signOutBtn" onClick={logOut} className='border-0'>Log Out</Button>
                    </Col> */}
                    <Col span={24} className='text-center' >
                        <Link to={{ pathname: '/user-profile' }} >
                            <Button icon={<UserOutlined />}
                                style={{ width: "60%" }}
                                id="profileBtn"
                                onClick={() => props.setOpen(false)}>My Account</Button>
                        </Link>
                    </Col>
                    <Col span={24} className='text-center' >
                        <Button
                            style={{ width: "60%" }}
                            icon={<LogoutOutlined />} id="signOutBtn"
                            onClick={logOut}
                            className='border-0'>Log Out</Button>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}

